"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Determins the type of ref passed (either a function or object ref type) and sets the ref to the element
var setInnerRef = function setInnerRef(ref, element) {
  if (ref && 'current' in ref) {
    ref.current = element;
  } else if (typeof ref === 'function') {
    ref(element);
  }
}; // Accepts two refs that can be used on a single element via the returned ref function


var useCombinedRef = function useCombinedRef(firstRef, secondRef) {
  return _react["default"].useMemo(function () {
    if (!firstRef && !secondRef) {
      return null;
    }

    return function (element) {
      setInnerRef(firstRef, element);
      setInnerRef(secondRef, element);
    };
  }, [firstRef, secondRef]);
};

var _default = useCombinedRef;
exports["default"] = _default;